import React from 'react';

const Logo = ({ className = '', color = 'currentColor', width = 200, height = 50 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 200 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      {/* Window/Door Icon */}
      <g className="logo-icon">
        {/* Frame */}
        <path d="M15 10h20v30H15V10z" stroke="currentColor" strokeWidth="2" fill="none"/>
        {/* Window Panes */}
        <path d="M25 10v30" stroke="currentColor" strokeWidth="2"/>
        <path d="M15 25h20" stroke="currentColor" strokeWidth="2"/>
        {/* Leaf Accent */}
        <path d="M32 15c0 0 3-3 6 0s0 6 0 6" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      </g>
      
      {/* Company Name */}
      <g className="logo-text" style={{ fontFamily: 'Nunito, sans-serif' }}>
        <text x="45" y="25" fill="currentColor" fontSize="16" fontWeight="700">ERNESTO</text>
        <text x="45" y="38" fill="currentColor" fontSize="14" fontWeight="600">WINDOWS</text>
        <text x="45" y="47" fill="currentColor" fontSize="10" fontWeight="500">&amp; DOORS LLC</text>
      </g>
      
      {/* Optional: Add a subtle shield outline for protection concept */}
      <path 
        className="logo-shield" 
        d="M10 12c0 0 2-5 15-5s15 5 15 5c0 0-2 25-15 25S10 12 10 12z" 
        stroke="currentColor" 
        strokeWidth="0.5" 
        fill="none" 
        opacity="0.3"
      />
    </svg>
  );
};

export default Logo; 